import { render, staticRenderFns } from "./DialogUsers.vue?vue&type=template&id=2f8d18e1"
import script from "./DialogUsers.vue?vue&type=script&lang=js"
export * from "./DialogUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports